// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__20KMv","colMin":"styles_colMin__3X2rL","colCheckbox":"styles_colCheckbox__GvFdr"};